import React from 'react'

export default class Autoscroll extends React.Component {
    constructor(props) {
        super(props)
        this.ref = React.createRef()
        this.shouldAutoscroll = true
    }

    componentDidUpdate() {
        const { shouldAutoscroll } = this
        if (!shouldAutoscroll)
            return
        const { current } = this.ref
        current.scrollTo(0, current.scrollHeight)
    }

    handleScroll = (e) => {
        const { current } = this.ref
        const scrollToBottom = current.scrollHeight - current.offsetHeight
        if (current.scrollTop < scrollToBottom - 10)
            this.shouldAutoscroll = false
        else
            this.shouldAutoscroll = true
    }

    render() {
        const { children, ...rest } = this.props

        return (<div {...rest} ref={this.ref} onScroll={this.handleScroll}>
            {children}
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/components/Autoscroll.js